import axios from '@global/axios';
import { apiUrl, ToastMessage } from '@app/constants';
import createFetchTypes from '@app/utils/createFetchTypes';
import { createContactAttributeType } from './types';
import { FilterOptions } from '@app/types';

const mainType = 'contactAttributes';
const ROUTE = 'contactAttributes';

export const getContactAttributesTypes = createFetchTypes(
	`${mainType}_GET_CONTACT_ATTRIBUTES`,
);

export const getAttributeValuesTypes = createFetchTypes(
	`${mainType}_GET_ATTRIBUTE_VALUES`,
);

export const createContactAttributeTypes = createFetchTypes(
	`${mainType}_CREATE_CONTACT_ATTRIBUTE`,
);

export const editContactAttributeTypes = createFetchTypes(
	`${mainType}_EDIT_CONTACT_ATTRIBUTE`,
);

function getContactAttributes(filter?: FilterOptions) {
	const filterObject = JSON.stringify(filter);
	return {
		type: getContactAttributesTypes,
		callAPI: () =>
			axios.get(
				`${apiUrl}/${ROUTE}${!!filter ? `?filter=${filterObject}` : ''}`,
			),
		payload: {
			custom: '',
		},
	};
}

// ATTRIBUTE VALUES
function getAttributeValues(filter: FilterOptions, isDistinct: boolean) {
	const filterString = JSON.stringify(filter);
	return {
		type: getAttributeValuesTypes,
		callAPI: () =>
			axios.get(
				`${apiUrl}/contactAttributeValue/${isDistinct ? 'distinct/' : ''}${!!filter ? `?filter=${filterString}` : ''}`,
			),
		payload: {
			custom: 'getAttributeValues',
		},
	};
}

function createContactAttribute(data: createContactAttributeType) {
	return {
		type: createContactAttributeTypes,
		callAPI: () => axios.post(`${apiUrl}/${ROUTE}`, data),
		payload: {
			custom: 'createContactAttribute',
			errorMessage: ToastMessage.error,
		},
	};
}

function editContactAttribute(
	id: string,
	data: { contactAttribute: createContactAttributeType },
) {
	return {
		type: editContactAttributeTypes,
		callAPI: () => axios.put(`${apiUrl}/${ROUTE}/${id}`, data),
		payload: {
			custom: 'editContactAttribute',
			errorMessage: ToastMessage.error,
		},
	};
}

export {
	getContactAttributes,
	getAttributeValues,
	createContactAttribute,
	editContactAttribute,
};
